<script lang="ts" setup>
import PackingSlipPackageForm from "@/data-views/forms/packing_slip_package/Form.vue";
definePage({
  meta: {
    action: "read_write",
    subject: "PackingSlipPackage",
  },
});
</script>

<template>
  <div>
    <PackingSlipPackageForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
